import { createSelector } from 'reselect';
import { createErrorDataSelector } from 'selectors/selectorUtils';

// Direct selector — no GeneralFilter dependency.
// isAdminFromCIAM controls whether 365-day date range is available.
const isAdmin = ({ overview }) => overview?.user?.data?.isAdminFromCIAM === true;


const getActiveTab = ({ chartView }) => {
    return chartView?.activeTab;
};

const getDateSelection = ({ overview }) => {
    return overview?.dateSelection;
};

const getChartStatusError = ({ chartView }) => ({
    loadingStatus: chartView?.chartStatus?.loadingStatus,
    error: chartView?.chartStatus?.error,
    errorCode: chartView?.chartStatus?.error?.statusCode
});

const getChartErrorData = createErrorDataSelector(getChartStatusError);

export const getModel = createSelector([
    getActiveTab,
    getDateSelection,
    isAdmin,
    getChartErrorData
],
    (
        activeTab,
        dateSelection,
        isAdmin,
        chartErrorData
    ) => {
        return {
            activeTab,
            dateSelection,
            isAdmin,
            chartErrorData
        };
    });
